import * as React from 'react';

export default () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 69.014085 69.014085"
    fill="none"
    version="1.1"
    id="svg416"
    xmlns="http://www.w3.org/2000/svg">
    <defs id="defs420" />
    <rect
      y="0"
      width="69.014084"
      height="69.014084"
      rx="34.507042"
      fill="#6fbeff"
      fill-opacity="60%"
      id="rect412"
      x="0"
      strokeWidth="0.985916"
    />
    <path
      d="m 23.2878,32.3564 c -1.7546,0 -3.1901,1.4356 -3.1901,3.1901 0,1.7546 1.4355,3.1902 3.1901,3.1902 1.7545,0 3.1901,-1.4356 3.1901,-3.1902 0,-1.7545 -1.4356,-3.1901 -3.1901,-3.1901 z m 22.3307,0 c -1.7546,0 -3.1901,1.4356 -3.1901,3.1901 0,1.7546 1.4355,3.1902 3.1901,3.1902 1.7545,0 3.1901,-1.4356 3.1901,-3.1902 0,-1.7545 -1.4356,-3.1901 -3.1901,-3.1901 z m -11.1654,0 c -1.7545,0 -3.1901,1.4356 -3.1901,3.1901 0,1.7546 1.4356,3.1902 3.1901,3.1902 1.7546,0 3.1901,-1.4356 3.1901,-3.1902 0,-1.7545 -1.4355,-3.1901 -3.1901,-3.1901 z"
      stroke="#ffffff"
      strokeWidth="1.5"
      id="path414"
    />
  </svg>
);
